/** Angles in degrees, measured clockwise from twelve o'clock. */
const BOTTOM = 180;
const FULL_TURN = 360;

const SIZE = 246;
const SWEEP = 260;

/**
 * The dial: a 260° arc whose opening is centred on the bottom. The start angle is derived from the
 * sweep and that centre, so changing the sweep keeps the opening at the bottom.
 */
/**
 * Share of the ring's diameter taken by the disc at the centre, read from the reference drawing
 * (122px across a 192px ring). The disc is derived from the ring and never set on its own: the
 * two have to keep their proportion whatever the dial's size becomes.
 */
const CENTRE_SHARE = 122 / 192;

const RADIUS = 96;

export const ARC = {
    size: SIZE,
    radius: RADIUS,
    stroke: 14,
    /** Diameter of the disc the picture fills, halo included. */
    centreDiameter: Math.round(RADIUS * 2 * CENTRE_SHARE),
    sweep: SWEEP,
    startAngle: BOTTOM + (FULL_TURN - SWEEP) / 2,
};

const ARC_CENTRE = ARC.size / 2;

/** A point of the arc's circle; every point the dial draws goes through here. */
export const polarToCartesian = (angle: number) => {
    const radians = ((angle - 90) * Math.PI) / 180;
    return {
        x: ARC_CENTRE + ARC.radius * Math.cos(radians),
        y: ARC_CENTRE + ARC.radius * Math.sin(radians),
    };
};
